export const generateArrayIds = (length: number): string[] => {
  return Array.from({ length }).map(() => crypto.randomUUID())
}
